<template>
  <div class='mailList'>
    <p class="gray font15" v-if="list.length>0">{{list.length}}个联系人</p>
    <div class="list">
       <div class="listCon flex-between"  v-for='(item,i) in list' :key='i' @click='gotoUrl("addressBookAdd",Object.assign({color:colors[getNum(i)]},item))'>
          <div>  
            <div :class="'text bg'+getNum(i)" :style="'background:#'+colors[getNum(i)]">{{item.contractName.substring(0,1)}}</div>
            <div class='con'>
                <p class='tit font18 flex-between'><span>{{item.contractName}}</span>
                  <span class='sos' v-if="item.sos==1">SOS联系人</span>
                </p>
                <div class='tel font15'>{{item.phone}}</div>
            </div> 
          </div>
          <p class='optBtn'><svg-icon icon-class="right"/></p>
       </div>
     </div>
   
    <div class='btn'>
      <div class="btn-primary" @click="getImei" >添加联系人</div>
    </div>

    <div class='noData' v-if="text&&list.length==0"><div><img :src='require("@/assets/img/equipment/addressNodata.png")'><br />{{text}}</div></div>
    
    
  </div>
</template>
<script>
import {listQuery} from "@/api/api.equipment";
  export default {
    data() {
      return {
        list:'',
        isAdd:false,
        contractName:'',
        kinship:'',
        phone:'',
        sos:false,
        text:'',
        curData:'',
        options:[],
        loading:false,
        colors:{0:'B7C5D2',2:'BBB2C7',4:'D3BFB8',6:'B7C6B3',8:'D2CAB3'},
      }
    },
   created(){
     this.getList();
    },
    methods: {
      getNum(i){
        let num=(i/5).toFixed(1).split('.');
        return num[1]
      },
      getAdd(){
        if(this.list.length==20){
          this.$toast('通讯录上限为20个，请先删除再重新添加')
        }else{
          this.gotoUrl('addressBookAdd');

        }
        
      },
      getList(){
         listQuery({
              studentId:this.loginUser.studentId
           }).then((data) => {
             this.loading=false;
            if (data && data.result.length>0) {
              data.result.forEach(item=>{
                item.isClick=true;
              })
              this.list=data.result;
            }else{
              this.list=[];
              this.text='暂无联系人';
            }
           })
       },
       getImei(){
         let option={
              success:(data)=>{
                  if(data.deviceStatus!==1){
                    this.$toast('设备离线，无法操作');
                    return false;
                  }
                  this.getAdd();
                  
              } 
          }
          this.getImeis(option);
      },
    
    },
  }
</script>
<style lang="scss" >
.mailList{
  padding:.12rem .12rem 1rem;
  .addBtn{
      background: #fff;
      padding:.08rem 0px;
      width: 100%;
      position: fixed;
      bottom: 0px;
      left: 0px;
      p{
        border:1px solid #2403df;
        border-radius:40px;
        line-height: .44rem;
        text-align: center;
        color: #2403df;
        font-size: .15rem; 
        width: 80%;
        margin:0px auto;
      }
  }
  .list{
    margin:.12rem auto;
    border-radius: .1rem;
    background: #fff;
    .listCon{
      position: relative;
      padding:.16rem .12rem;
      display: flex;
      align-items: center;
      &::after{
        content:'';
        width: calc(100% - .62rem);
        height: 1px;
        background: #DCDCDC;
        display: block;
        position: absolute;
        right: 0px;
        bottom: 0px;
      }
      &:last-child{
        &::after{
          display: none;
        }
      }
      .text{
        width:.5rem;
        height:.5rem;
        border-radius:50%;
        margin-right: .1rem;
        line-height: .5rem;
        font-size: .18rem;
        text-align: center;
        display: inline-block;
        color: #fff;
        background: #B7C5D2;
        vertical-align:top;
       
      }
      .con{
          display: inline-block;
          color: rgba(0,0,0,.9);
          .sos{
            background: #FF4A4A;
            color:#fff;
            border-radius:3px;
            padding:.02rem .05rem;
            font-size: .1rem;
            margin-left:.04rem;
          }
          .tel{
            padding-top: .07rem;
            font-size: .15rem;
            color:rgba(0,0,0,.6)
          }
      }
     
    }
    
  }
  .van-dropdown-menu{
    width: 70%;
    .van-cell{
      font-size: .14rem;
      padding:0.03rem .1rem;
      line-height: .25rem;
    }
     .van-dropdown-menu__item{
        justify-content: flex-end;
      }
      .van-dropdown-menu__bar{
        box-shadow: none;
        height:.48rem;
        .van-dropdown-menu__title{
          font-size: .14rem;
          line-height: normal;
          padding-right: .1rem;
          &::after{
            border:.03rem solid;
            border-color: transparent transparent #959799 #959799;
          }
        }
      }
  }
  
  .van-button--normal{
        height: 100%;
  }
  .flex{
     display: flex;
     justify-content: space-between;
 }
 .addCon{
   .formTxt{
     line-height:.56rem;
     font-size: .14rem;
     p{
       width: 74%;
       text-align: right;
       &.address{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;}
     }
     input{
       border:none;
       line-height: 30px;
       height: 30px;
       text-align: right;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis;
       width: 100%;
     }
   }
 
 }
 .btn{
      position: fixed;
      bottom:0rem;
      padding: .2rem .2rem .48rem;
      text-align: center;
      width: 100%;
      left:0;
      background:#f4f7fd;
      z-index: 1;
  } 
}

</style>